import { render, staticRenderFns } from "./CheckoutWizardStepAddresses.vue?vue&type=template&id=3edb8e87&scoped=true"
import script from "./CheckoutWizardStepAddresses.vue?vue&type=script&lang=ts"
export * from "./CheckoutWizardStepAddresses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb8e87",
  null
  
)

export default component.exports